<template>
  <v-row>
    <!-- <v-col cols="12" md="6" class="d-flex flex-row">
      <v-text-field
        name="name"
        label="Pesquise um médico"
        hint="Você está buscando por médicos no dia xx"
        id="id"
      ></v-text-field>
    </v-col> -->
    <v-col cols="12" md="12">
      <HorariosSlider @update-data="buscarHorarios" />
    </v-col>
    <template v-if="loadingHorarios">
      <v-col cols="12" md="4" v-for="n in 3" :key="n">
        <v-skeleton-loader type="list-item-avatar, list-item-three-line"></v-skeleton-loader>
      </v-col>
    </template>
    <template v-else-if="medicos.length > 0">
      <v-col v-for="medico in medicos" :key="medico.id" cols="12" md="4" class="mb-3">
        <MedicoCard
          :medico="medico"
          v-if="!loadingHorarios"
          :horario="selectedHorario"
          @select-horario="selectHorario"
        />
      </v-col>
    </template>
    <v-col cols="12" v-else>
      Não encontramos nenhum horário disponível nesse dia :(
    </v-col>
    <v-col cols="12" class="erro-message" v-if="horarioError">
      É obrigatório escolher um horário
    </v-col>
    <v-col cols="12" class="justify-space-between d-flex">
      <v-btn color="primary" large rounded @click="previousStep()">
        <v-icon>mdi-chevron-left</v-icon>
        Anterior
      </v-btn>
      <v-btn color="primary" large rounded @click="nextStep()">
        Próximo
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import acessoRapidoService from '@/services/acessoRapido'
import HorariosSlider from './components/HorariosSlider'
import MedicoCard from './components/MedicoCard'

export default {
  name: 'EscolherHorario',
  props: {
    value: {
      type: Object,
      required: true
    },
    horario: {
      type: Number
    }
  },
  data() {
    return {
      datas: [],
      loadingHorarios: true,
      medicos: [],
      selectedHorario: null,
      horarioError: false
    }
  },
  components: {
    HorariosSlider,
    MedicoCard
  },
  methods: {
    nextStep() {
      if (this.selectedHorario) {
        this.$emit('update-horario', this.selectedHorario)
        this.$emit('next-step')
      } else {
        this.horarioError = true
      }
    },
    previousStep() {
      this.$emit('previous-step')
    },
    selectHorario(horario) {
      this.horarioError = false
      this.selectedHorario = horario
    },
    async buscarHorarios(dataSelecionada) {
      try {
        this.loadingHorarios = true
        const { data } = await acessoRapidoService.buscaHorarios(dataSelecionada, this.value.cpf)
        this.medicos = data
      } catch (error) {
        console.log(error)
        this.$showErrorMessage(error.response.data.message)
      } finally {
        this.loadingHorarios = false
      }
    }
  },
  mounted() {
    if (this.value.idHorario) this.selectedHorario = this.value.idHorario
  }
}
</script>

<style scoped>
.horarios-table {
  font-size: 0.85rem;
  width: 100%;
}
.erro-message {
  background-color: #fbc3c3;
  color: red;
  border-radius: 30px;
}
</style>
